<template>
    <div class="field select-label" :class="{ 'is-danger': errors.hasError( name ) }">
        <label :for="name" class="label" v-text="label"></label>
        <div class="select is-fullwidth" :class="{ 'is-loading': loading }" style="height: 100%">
            <select :name="name" :id="name"
                    :required="required" v-model="input">
                <option v-if="! loading"
                        v-for="element in elements"
                        :key="element.id"
                        :value="element.id"
                        :selected="element.id === input"
                        v-text="getElementText( lang( element ) )"></option>

                <option v-else>Caricamento</option>
            </select>
        </div>
        <p class="help is-danger" v-text="errors.get(name)"></p>
    </div>
</template>
<script>
    import axios from 'axios';
    import _ from 'lodash'

    export default {
        props: {
            value: null,
            name: {
                type: String,
                required: true
            },
            label: {
                type: String,
                required: true
            },
            required: {
                type: Boolean,
                required: false,
                default: false
            },
            errors: {
                type: Object,
                required: false
            },
            endpoint: {
                type: String,
                required: false,
            },
            options: {
                type: [Array, Object],
                required: false
            },
            ordering: {
              type: String,
              required: false
            }
        },
        data() {
            return {
                loading: true,
                elements: [],
                input: ''
            }
        },
        mounted() {
            let self = this;
            if( this.value !== undefined) this.input = this.value;
            if( this.endpoint && ( ! this.options || _.isEmpty( this.options ) ) ) {
                axios.get('https://preventivi.daku.it/api/v1.0/'+this.endpoint)
                     .then( response => {
                          if(this.ordering) {
                            response.data = _.orderBy(response.data, this.ordering,['asc']);
                          }

                          if(this.required) {
                            response.data = _.filter(response.data, function (x) {
                              return _.trim(x.name) !== '';
                            });

                            response.data.splice(0, 0, {id : '', name: self.lang('Seleziona') + ' ' + self.label});
                          }

                       this.elements = response.data;
                       this.loading = false;
                     })
            }

            if( this.options && ! _.isEmpty( this.options )) {
                this.elements = this.options;
                this.loading = false;
            }
        },
        methods: {
            getElementText( element ) {
                if( element.name === '' || element.name === ' ' ||  element.name === null) return 'Seleziona ' + this.label;
                return element.name
            }
        },
        watch: {
            value( value ) {
                this.input = value
            },
            input( value ) {
                this.errors.clear( this.name );
                this.$emit('input', value);
            },
            options( options ) {
                if( ! _.isEmpty( options ) ) {
                    this.elements = this.options;
                    this.loading = false;
                }
            }
        }
    }
</script>